export const imdbRegex =
  /(^https:\/\/www\.imdb\.com\/user\/ur(\d)+(.+)?$)|(^http:\/\/www\.imdb\.com\/user\/ur(\d)+(.+)?$)/;
export const instagramRegex = /^[a-zA-Z0-9_]+$/;
export const YoutubeRegex =
  /^(?:https?:\/\/)?(?:m\.|www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/;

export const SidebarItems = [
  {
    label: "Actor",
    href: "/admin/actor",
    // icon: <DashboardOutlined className="w-6 h-6" />,
  },
  {
    label: "Influencer",
    href: "/admin/influencer",
    // icon: <GroupAddRounded className="w-6 h-6" />,
  },
  {
    label: "Director",
    href: "/admin/director",
    // icon: <SchoolRounded className="w-6 h-6" />,
  },
  {
    label: "Auditions",
    href: "/admin/auditions",
    // icon: <Person3Rounded className="w-6 h-6" />,
  },
  {
    label: "KYC List",
    href: "/admin/kyc",
    // icon: <Person3Rounded className="w-6 h-6" />,
  },
];

export const genderOptions = [
  { label: "Male", value: "Male" },
  { label: "Female", value: "Female" },
  { label: "Other", value: "Other" },
];

export const genderFullOptions = [
  { label: "Male", value: "Male" },
  { label: "Female", value: "Female" },
  { label: "Other", value: "Other" },
];

export const contactPrivacyOptions = [
  { label: "Private", value: "PRIVATE" },
  { label: "Public", value: "PUBLIC" },
  { label: "Handled by Starnex", value: "MANAGED" },
];

export const languagesOptions = [
  { label: "Hindi", value: "Hindi" },
  { label: "English", value: "English" },
  { label: "Assamese", value: "Assamese" },
  { label: "Bengali", value: "Bengali" },
  { label: "Gujarati", value: "Gujarati" },
  { label: "Odia", value: "Odia" },
  { label: "Punjabi", value: "Punjabi" },
  { label: "Kannada", value: "Kannada" },
  { label: "Marathi", value: "Marathi" },
  { label: "Tamil", value: "Tamil" },
  { label: "Kashmiri", value: "Kashmiri" },
  { label: "Konkani", value: "Konkani" },
  { label: "Malayalam", value: "Malayalam" },
  { label: "Nepali", value: "Nepali" },
  { label: "Sanskrit", value: "Sanskrit" },
  { label: "Sindhi", value: "Sindhi" },
  { label: "Urdu", value: "Urdu" },
  { label: "Bodo", value: "Bodo" },
  { label: "Dogri", value: "Dogri" },
  { label: "Manipuri", value: "Manipuri" },
  { label: "Telugu", value: "Telugu" },
  { label: "Maithili", value: "Maithili" },
  { label: "Santali", value: "Santali" },
  { label: "Haryanvi", value: "Haryanvi" },
  { label: "Bhojpuri", value: "Bhojpuri" },
];

export const locationDropdownOptions = [
  { label: "Delhi", value: "Delhi" },
  { label: "Mumbai", value: "Mumbai" },
  { label: "Bangalore", value: "Bangalore" },
  { label: "Chennai", value: "Chennai" },
  { label: "Hyderabad", value: "Hyderabad" },
  { label: "Kolkata", value: "Kolkata" },
  { label: "Ahmedabad", value: "Ahmedabad" },
  { label: "Pune", value: "Pune" },
  { label: "Lucknow", value: "Lucknow" },
  { label: "Jaipur", value: "Jaipur" },
];

export const locationFilterOptions = [
  { label: "Delhi", value: "Delhi" },
  { label: "Mumbai", value: "Mumbai" },
  { label: "Bangalore", value: "Bangalore" },
  { label: "Chennai", value: "Chennai" },
  { label: "Hyderabad", value: "Hyderabad" },
  { label: "Kolkata", value: "Kolkata" },
  { label: "Ahmedabad", value: "Ahmedabad" },
  { label: "Pune", value: "Pune" },
  { label: "Lucknow", value: "Lucknow" },
  { label: "Jaipur", value: "Jaipur" },
];

export const experienceCategoryOptions = [
  { label: "CELEBRITIES", value: "CELEBRITIES" },
  { label: "EXPERIENCED", value: "EXPERIENCED" },
  { label: "INTERMEDIATE", value: "INTERMEDIATE" },
  { label: "BEGINNER", value: "BEGINNER" },
];

export const locationOptions = [
  { description: "Delhi" },
  { description: "Mumbai" },
  { description: "Bangalore" },
  { description: "Chennai" },
  { description: "Hyderabad" },
  { description: "Kolkata" },
  { description: "Ahmedabad" },
  { description: "Pune" },
  { description: "Lucknow" },
  { description: "Jaipur" },
];

export const kycDocumentsOptions = [
  { label: "Aadhaar Letter/Card", value: "Aadhaar Letter/Card" },
  { label: "Passport", value: "Passport" },
  { label: "Voter's Identity Card", value: "Voter's Identity Card" },
  { label: "Driving Licence", value: "Driving Licence" },
  { label: "NREGA Card", value: "NREGA Card" },
];

export const numberlookup = [
  { value: 1, symbol: "" },
  { value: 1e3, symbol: "K" },
  { value: 1e6, symbol: "M" },
  { value: 1e9, symbol: "G" },
  { value: 1e12, symbol: "T" },
  { value: 1e15, symbol: "P" },
  { value: 1e18, symbol: "E" },
];

export const initialFolder = {
  id: "Parent",
  name: "Favourite",
  colour: "F8C630",
  parentId: undefined,
};

export const colorPicker = [
  { label: "Saffron", value: "F8C630", color: "#F8C630" },
  { label: "Red", value: "FF0000", color: "#FF0000" },
  { label: "Cyan", value: "00FFFF", color: "#00FFFF" },
  { label: "Blue", value: "0000FF", color: "#0000FF" },
  { label: "Purple", value: "800080", color: "#800080" },
  { label: "Light Blue", value: "ADD8E6", color: "#ADD8E6" },
  { label: "Yellow", value: "FFFF00", color: "#FFFF00" },
  { label: "Lime", value: "00FF00", color: "#00FF00" },
  { label: "Magenta", value: "FF00FF", color: "#FF00FF" },
  { label: "Silver", value: "C0C0C0", color: "#C0C0C0" },
  { label: "Grey", value: "808080", color: "#808080" },
  { label: "Orange", value: "FFA500", color: "#FFA500" },
  { label: "Brown", value: "A52A2A", color: "#A52A2A" },
  { label: "Maroon", value: "800000", color: "#800000" },
  { label: "Green", value: "008000", color: "#008000" },
  { label: "Olive", value: "808000", color: "#808000" },
  { label: "Aquamarine", value: "7FFFD4", color: "#7FFFD4" },
  { label: "Pink", value: "FFC0CB", color: "#FFC0CB" },
];

export const sortByOptions = [
  { label: "Most Popular", value: "mostpopular" },
  { label: "Most Recent", value: "mostrecent" },
];

export const MediaTagsTypes = {
  FACE_STRUCTURE: "Face Structure",
  HAIR_LENGTH: "Hair Length",
  HAIR_TYPE: "Hair Type",
  SKIN_COLOR: "Skin Color",
  BEARD: "Beard",
  EYE_COLOR: "Eye Color",
  BODY_TYPE: "Body Type",
};

export const heightUnitOptions = [
  { label: "cm", value: "cm" },
  { label: "feet", value: "feet" },
  { label: "inches", value: "inches" },
];

export const hairTypesOptions = [
  { label: "Straight Hair", value: "Straight Hair" },
  { label: "Wavy Hair", value: "Wavy Hair" },
  { label: "Curly Hair", value: "Curly Hair" },
  { label: "Coily Hair", value: "Coily Hair" },
];

export const extraCurricularOptions = [
  { label: "Acting", value: "Acting" },
  { label: "Singing", value: "Singing" },
  { label: "Anchoring", value: "Anchoring" },
  { label: "Voice Over", value: "Voice Over" },
  { label: "Dancing", value: "Dancing" },
  { label: "Modelling", value: "Modelling" },
  { label: "Music Instruments", value: "Music Instruments" },
  { label: "Skateboard", value: "Skateboard" },
  { label: "Stunts", value: "Stunts" },
  { label: "Martial Arts", value: "Martial Arts" },
  { label: "Calisthenics", value: "Calisthenics" },
  { label: "Horse Riding", value: "Horse Riding" },
];

export const faceStructureOptions = ["OVAL", "ROUND", "PEAR", "SQUARE"];
export const hairTypeOptions = ["STRAIGHT", "WAVY", "CURLY", "COILY"];
export const hairLengthOptions = ["SHORT", "MEDIUM", "LONG", "EXTRA LONG"];
export const beardOptions = ["STUBBLE", "SHORT", "MEDIUM", "FULL"];
export const skinColorOptions = ["FAIR", "LIGHT", "MEDIUM", "DARK"];
export const eyeColorOptions = ["BLACK", "BROWN", "BLUE", "GREEN"];
export const bodyTypeOptions = ["SKINNY", "NORMAL", "MUSCULAR", "PLUS SIZE"];

export const nationalityOptions = [
  { label: "Indian" },
  { label: "Afghan" },
  { label: "Albanian" },
  { label: "Algerian" },
  { label: "American" },
  { label: "Andorran" },
  { label: "Angolan" },
  { label: "Antiguans" },
  { label: "Argentinean" },
  { label: "Armenian" },
  { label: "Australian" },
  { label: "Austrian" },
  { label: "Azerbaijani" },
  { label: "Bahamian" },
  { label: "Bahraini" },
  { label: "Bangladeshi" },
  { label: "Barbadian" },
  { label: "Barbudans" },
  { label: "Batswana" },
  { label: "Belarusian" },
  { label: "Belgian" },
  { label: "Belizean" },
  { label: "Beninese" },
  { label: "Bhutanese" },
  { label: "Bolivian" },
  { label: "Bosnian" },
  { label: "Brazilian" },
  { label: "British" },
  { label: "Bruneian" },
  { label: "Bulgarian" },
  { label: "Burkinabe" },
  { label: "Burmese" },
  { label: "Burundian" },
  { label: "Cambodian" },
  { label: "Cameroonian" },
  { label: "Canadian" },
  { label: "Cape Verdean" },
  { label: "Central African" },
  { label: "Chadian" },
  { label: "Chilean" },
  { label: "Chinese" },
  { label: "Colombian" },
  { label: "Comoran" },
  { label: "Congolese" },
  { label: "Costa Rican" },
  { label: "Croatian" },
  { label: "Cuban" },
  { label: "Cypriot" },
  { label: "Czech" },
  { label: "Danish" },
  { label: "Djibouti" },
  { label: "Dominican" },
  { label: "Dutch" },
  { label: "East Timorese" },
  { label: "Ecuadorean" },
  { label: "Egyptian" },
  { label: "Emirian" },
  { label: "Equatorial Guinean" },
  { label: "Eritrean" },
  { label: "Estonian" },
  { label: "Ethiopian" },
  { label: "Fijian" },
  { label: "Filipino" },
  { label: "Finnish" },
  { label: "French" },
  { label: "Gabonese" },
  { label: "Gambian" },
  { label: "Georgian" },
  { label: "German" },
  { label: "Ghanaian" },
  { label: "Greek" },
  { label: "Grenadian" },
  { label: "Guatemalan" },
  { label: "Guinea-Bissauan" },
  { label: "Guinean" },
  { label: "Guyanese" },
  { label: "Haitian" },
  { label: "Herzegovinian" },
  { label: "Honduran" },
  { label: "Hungarian" },
  { label: "I-Kiribati" },
  { label: "Icelander" },
  { label: "Indonesian" },
  { label: "Iranian" },
  { label: "Iraqi" },
  { label: "Irish" },
  { label: "Israeli" },
  { label: "Italian" },
  { label: "Ivorian" },
  { label: "Jamaican" },
  { label: "Japanese" },
  { label: "Jordanian" },
  { label: "Kazakhstani" },
  { label: "Kenyan" },
  { label: "Kittian and Nevisian" },
  { label: "Kuwaiti" },
  { label: "Kyrgyz" },
  { label: "Laotian" },
  { label: "Latvian" },
  { label: "Lebanese" },
  { label: "Liberian" },
  { label: "Libyan" },
  { label: "Liechtensteiner" },
  { label: "Lithuanian" },
  { label: "Luxembourger" },
  { label: "Macedonian" },
  { label: "Malagasy" },
  { label: "Malawian" },
  { label: "Malaysian" },
  { label: "Maldivan" },
  { label: "Malian" },
  { label: "Maltese" },
  { label: "Marshallese" },
  { label: "Mauritanian" },
  { label: "Mauritian" },
  { label: "Mexican" },
  { label: "Micronesian" },
  { label: "Moldovan" },
  { label: "Monacan" },
  { label: "Mongolian" },
  { label: "Moroccan" },
  { label: "Mosotho" },
  { label: "Motswana" },
  { label: "Mozambican" },
  { label: "Namibian" },
  { label: "Nauruan" },
  { label: "Nepalese" },
  { label: "New Zealander" },
  { label: "Nicaraguan" },
  { label: "Nigerian" },
  { label: "Nigerien" },
  { label: "North Korean" },
  { label: "Northern Irish" },
  { label: "Norwegian" },
  { label: "Omani" },
  { label: "Pakistani" },
  { label: "Palauan" },
  { label: "Panamanian" },
  { label: "Papua New Guinean" },
  { label: "Paraguayan" },
  { label: "Peruvian" },
  { label: "Polish" },
  { label: "Portuguese" },
  { label: "Qatari" },
  { label: "Romanian" },
  { label: "Russian" },
  { label: "Rwandan" },
  { label: "Saint Lucian" },
  { label: "Salvadoran" },
  { label: "Samoan" },
  { label: "San Marinese" },
  { label: "Sao Tomean" },
  { label: "Saudi" },
  { label: "Scottish" },
  { label: "Senegalese" },
  { label: "Serbian" },
  { label: "Seychellois" },
  { label: "Sierra Leonean" },
  { label: "Singaporean" },
  { label: "Slovakian" },
  { label: "Slovenian" },
  { label: "Solomon Islander" },
  { label: "Somali" },
  { label: "South African" },
  { label: "South Korean" },
  { label: "Spanish" },
  { label: "Sri Lankan" },
  { label: "Sudanese" },
  { label: "Surinamer" },
  { label: "Swazi" },
  { label: "Swedish" },
  { label: "Swiss" },
  { label: "Syrian" },
  { label: "Taiwanese" },
  { label: "Tajik" },
  { label: "Tanzanian" },
  { label: "Thai" },
  { label: "Togolese" },
  { label: "Tongan" },
  { label: "Trinidadian or Tobagonian" },
  { label: "Tunisian" },
  { label: "Turkish" },
  { label: "Tuvaluan" },
  { label: "Ugandan" },
  { label: "Ukrainian" },
  { label: "Uruguayan" },
  { label: "Uzbekistani" },
  { label: "Venezuelan" },
  { label: "Vietnamese" },
  { label: "Welsh" },
  { label: "Yemenite" },
  { label: "Zambian" },
  { label: "Zimbabwean" },
];

export const kycStatusOptions = [
  { label: "KYC NOT GENERATED", value: "na" },
  { label: "APPROVED", value: "APPROVED" },
  { label: "PENDING", value: "PENDING" },
];

export const AdminTestNumber = "9991382371";

export const PaymentStatusPrefix = "paymentStatus=";

export const PaymentStatus = {
  Success: "SUCCESS",
  Failed: "FAILED",
  Unknown: "UNKNOWN",
  Error: "ERROR",
  Close: "CLOSE",
};

export const subscriptionPlanData = {
  "plan-month-699": {
    id: "plan-month-699",
    planDuration: "Month",
    month: 1,
    originalAmount: 2500,
    currentAmount: 699,
    amountInPaisa: 69900,
    amountPerMonth: 699,
  },
  "plan-6-month-3594": {
    id: "plan-6-month-3594",
    planDuration: "6 month",
    originalAmount: 11394,
    month: 6,
    currentAmount: 3594,
    amountInPaisa: 359400,
    amountPerMonth: 599,
  },
  "plan-12-month-3594": {
    id: "plan-12-month-3594",
    planDuration: "12 month",
    originalAmount: 17990,
    month: 12,
    currentAmount: 5988,
    amountInPaisa: 598800,
    amountPerMonth: 499,
  },
};

export const jobTypes = [
  { id: "OPEN_AUDITION", label: "Open Audition" },
  { id: "SHORTLIST_AND_INVITE", label: "Shortlisted & Invite" },
  { id: "ONLY_INVITE", label: "Only Invite" },
];

export const basicProfilecategory = {
  CASTING_DIRECTOR: "PC1697112621427",
  CASTING_AGENCY: "PC1697112621424",
  CREATIVE_AGENCY: "PC1697112621429",
  COORDINATOR: "PC1697112621425",
  THEATRE_GROUP: "PC1697112621426",
  PRODUCTION_HOUSE: "PC1697112621428",
  ACTOR: "PC1698918538181",
  MODEL: "PC1698918538167",
  INFLUENCER: "PC1698918538168",
};

export const projectTypeOptionss = [
  { id: "PC1695808147343", name: "MOVIE (REMOVED)" },
  { id: "PC1695808164112", name: "WEB SERIES (REMOVED)" },
  { id: "PC1698814338306", name: "OTT MOVIES (REMOVED)" },
  { id: "PC1702902261860", name: "OTT WEBSERIES" },
  { id: "PC1698814338307", name: "Film" },
  { id: "PC1698814338308", name: "Web Series" },
  { id: "PC1698814338309", name: "TV Serial" },
  { id: "PC1698814338310", name: "Short Film" },
  { id: "PC1698814338311", name: "Print Shoot" },
  { id: "PC1698814338312", name: "TVC ad" },
  { id: "PC1698814338313", name: "Digital ad" },
  { id: "PC1698814338314", name: "Campaign Shoot" },
];

export const artistCategoryOptions = [
  {
    defaultcategory: null,
    id: "PC1698918538181",
    level: "0",
    name: "ACTOR",
    type: "ARTIST",
  },
  {
    defaultcategory: null,
    id: "PC1698918538167",
    level: "1",
    name: "MODEL",
    type: "ARTIST",
  },
  {
    defaultcategory: null,
    id: "PC1698918538168",
    level: "2",
    name: "INFLUENCER",
    type: "ARTIST",
  },
  {
    defaultcategory: null,
    id: "PC1698918538169",
    level: "3",
    name: "WRITER",
    type: "ARTIST",
  },
  {
    defaultcategory: null,
    id: "PC1698918538170",
    level: "4",
    name: "SINGER",
    type: "ARTIST",
  },
  {
    defaultcategory: null,
    id: "PC1698918538171",
    level: "5",
    name: "DIRECTOR",
    type: "ARTIST",
  },
  {
    defaultcategory: null,
    id: "PC1698918538172",
    level: "6",
    name: "DANCER",
    type: "ARTIST",
  },
  {
    defaultcategory: null,
    id: "PC1698918538173",
    level: "7",
    name: "PHOTOGRAPHER",
    type: "ARTIST",
  },
  {
    defaultcategory: null,
    id: "PC1698918538174",
    level: "8",
    name: "ANCHOR",
    type: "ARTIST",
  },
  {
    defaultcategory: null,
    id: "PC1698918538175",
    level: "9",
    name: "VOICE-OVER ARTIST",
    type: "ARTIST",
  },
  {
    defaultcategory: null,
    id: "PC1698918538176",
    level: "10",
    name: "STYLIST",
    type: "ARTIST",
  },
  {
    defaultcategory: null,
    id: "PC1698918538182",
    level: "11",
    name: "MAKEUP & HAIR",
    type: "ARTIST",
  },
  {
    defaultcategory: null,
    id: "PC1698918538177",
    level: "12",
    name: "FILMMAKER",
    type: "ARTIST",
  },
  {
    defaultcategory: null,
    id: "PC1698918538178",
    level: "13",
    name: "ADVERTISING PROFESSIONAL",
    type: "ARTIST",
  },
  {
    defaultcategory: null,
    id: "PC1698918538179",
    level: "14",
    name: "STAND-UP COMEDIAN",
    type: "ARTIST",
  },
  {
    defaultcategory: null,
    id: "PC1698918538180",
    level: "15",
    name: "JUNIOR ARTIST",
    type: "ARTIST",
  },
];

export const roleTypeListOptions = [
  { id: "RT1695464276808", name: "SUPPORTING MALE" },
  { id: "RT1695801396960", name: "SUPPORTING FEMALE" },
  { id: "RT1695801418484", name: "LEAD MALE" },
  { id: "RT1695801422250", name: "LEAD FEMALE" },
  { id: "RT1695801422251", name: "Lead" },
  { id: "RT1695801422252", name: "Primary" },
  { id: "RT1695801422253", name: "Secondary" },
  { id: "RT1695801422254", name: "Featured Cast" },
  { id: "RT1695801422255", name: "Tertiary (Junior)" },
  { id: "RT1695801422256", name: "Cameos" },
];

export const selectSelfTestOptions = [
  { label: "Open Audition", value: "OPEN_AUDITION" },
  { label: "Shortlist and Invite", value: "SHORTLIST_AND_INVITE" },
  { label: "Only Invite", value: "ONLY_INVITE" },
];
